// extracted by mini-css-extract-plugin
module.exports = {"textSlot":"DropdownMenu-module__textSlot___GbOsv","items":"DropdownMenu-module__items___n1ZNx","divider":"DropdownMenu-module__divider___YyRqe"};